import styled, {css} from 'styled-components';

import type {StyledProps} from './types';

import {ms} from '../../../../../styles/normalizeSize';
import {getColor} from '../../../../../styles/utils';
import {Button} from '../../../../../uikit/Button';
import {Text} from '../../../../../uikit/Text';

const containerCss = css<StyledProps>`
  background-color: ${p =>
    getColor(p.$isActive ? 'background4' : 'background2')(p)};
  border-color: ${p => (p.$isActive ? getColor('global1') : 'transparent')};
`;

export const Container = styled(Button)<StyledProps>`
  flex: 1;
  height: ${ms(58)};
  flex-direction: column;
  border-width: 1px;
  border-style: solid;

  ${containerCss};

  &:hover {
    ${containerCss};
  }
`;

export const Icon = styled(({component, ...rest}) => {
  const Component = component;

  return <Component {...rest} />;
}).attrs(p => ({
  fill: getColor(p.$isActive ? 'global1' : 'icon3')(p),
}))`
  width: ${ms(24)};
  height: ${ms(24)};
  margin-bottom: ${ms(4)};
`;

export const Label = styled(Text)<StyledProps>`
  font-size: ${ms(10)};
  line-height: ${ms(14)};
  letter-spacing: ${ms(0.12)};
  color: ${p => getColor(p.$isActive ? 'global1' : 'text3')(p)};
`;
